import React from 'react';
import { ScanResult } from './scannerUtils';

interface ScannerResultOverlayProps {
  result: ScanResult | null;
  onDismiss: () => void;
}

const CATEGORY: Record<string, string> = {
  visitor: 'Visiteur',
  exhibitor: 'Exposant',
  setup: 'Montage / démontage',
  organiser: 'Organisateur',
};

function formatTime(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

function getResultColor(result: ScanResult): string {
  if (!result) return '';
  if (result.accepted) {
    return result.result === 'reentry' ? '#d97706' : '#16a34a';
  }
  return '#dc2626';
}

export function ScannerResultOverlay({
  result,
  onDismiss,
}: ScannerResultOverlayProps): JSX.Element | null {
  if (!result) return null;

  const tone = getResultColor(result);
  const isAccepted = result.accepted;

  return (
    <button
      type="button"
      onClick={onDismiss}
      aria-label={`Résultat du scan : ${result.message}. ${
        !isAccepted ? 'Touchez pour continuer' : ''
      }`}
      aria-live="polite"
      style={{
        position: 'absolute',
        inset: 0,
        background: tone,
        color: '#fff',
        border: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 24,
        cursor: 'pointer',
      }}
    >
      <div style={{ fontSize: 64, lineHeight: 1 }}>
        {result.accepted ? (result.result === 'reentry' ? '↻' : '✓') : '✕'}
      </div>
      <div style={{ fontSize: 28, fontWeight: 700, marginTop: 12 }}>
        {result.message}
      </div>
      {result.ticket && (
        <>
          <div style={{ fontSize: 24, fontWeight: 600, marginTop: 16 }}>
            {result.ticket.name}
          </div>
          {result.ticket.company && (
            <div style={{ fontSize: 18, opacity: 0.9 }}>
              {result.ticket.company}
            </div>
          )}
          <div
            style={{
              marginTop: 8,
              fontSize: 13,
              textTransform: 'uppercase',
              letterSpacing: 1,
              background: 'rgba(0,0,0,.25)',
              borderRadius: 4,
              padding: '4px 8px',
            }}
          >
            {CATEGORY[result.ticket.category ?? ''] ?? ''}
            {result.ticket.type ? ` · ${result.ticket.type}` : ''}
          </div>
        </>
      )}
      {result.previous_entry_at && (
        <div style={{ marginTop: 8, fontSize: 14 }}>
          Première entrée aujourd&apos;hui à{' '}
          {formatTime(result.previous_entry_at)}
        </div>
      )}
      {result.offline && (
        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
          Vérifié hors ligne, sera synchronisé
        </div>
      )}
      {!result.accepted && (
        <div style={{ marginTop: 16, fontSize: 12, opacity: 0.8 }}>
          Touchez pour continuer
        </div>
      )}
    </button>
  );
}

export default ScannerResultOverlay;
